<template>
    <span>{{formattedValue}}</span>
</template>

<script>
    import moment from 'moment'
    import DateUtils from '../../service/date-utils'

    export default {
        name: "PrettyDateTime",
        props: {
            value:[String,Date,Number],
            format:{
                type: String,
                default: 'YYYY-MM-DD HH:mm:ss'
            },
            valueFormat:{
                type: String
            },
            javaFormat: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            formattedValue() {
                if (this.value) {
                    let momentValue
                    if (this.valueFormat) {
                        if(this.javaFormat){
                            momentValue = moment(this.value, DateUtils.toMomentFormatString(this.valueFormat))
                        }else{
                            momentValue = moment(this.value, this.valueFormat)
                        }
                    } else {
                        momentValue = moment(this.value)
                    }
                    if(this.javaFormat){
                        return momentValue.format(DateUtils.toMomentFormatString(this.format))
                    }else{
                        return momentValue.format(this.format)
                    }
                } else {
                    return ''
                }
            }
        }
    }
</script>

